import { Ban, CircleCheck, CircleDot, Clock3 } from "lucide-react";
import { ProductStatus } from "@/components/ProductStatus";

export const SUPPORT_STATUSES = {
  open: "Aperto", in_progress: "In lavorazione", completed: "Completato", cancelled: "Annullato",
};

export const SUPPORT_TONES = { open: "info", in_progress: "warning", completed: "success", cancelled: "danger" };
const symbols = { open: CircleDot, in_progress: Clock3, completed: CircleCheck, cancelled: Ban };

export const SupportStatus = ({ status, testId, large = false }) => {
  const Icon = symbols[status] || CircleDot;
  return <ProductStatus tone={SUPPORT_TONES[status] || "neutral"} icon={Icon}
                        className={large ? "support-ux-status--large" : ""} testId={testId}>
    {SUPPORT_STATUSES[status] || status}
  </ProductStatus>;
};

export const supportDate = value => value
  ? new Date(value).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
  : "—";